export const GET_ROLES = 'store/roles/GET_ROLES'
export const GET_PERMISSIONS = 'store/roles/GET_PERMISSIONS'
export const GET_PERMISSIONS_LIST = 'store/roles/GET_PERMISSIONS_LIST'
export const GET_ROLE_INFORMATION = 'store/roles/GET_ROLE_INFORMATION'
export const GET_ROLES_USERINFO = 'store/roles/GET_ROLES_USERINFO'



// WEBPACK FOOTER //
// ./src/actionTypes/Roles/Roles.js